export default "__VITE_ASSET__CxBqT1no__"